import { Input, LoadingPlaceholder, Select, TextArea } from '@trackman/web-shared-components';
import './EditGeneral.scss';
import { BannerImage } from './BannerImage/BannerImage';
import Subtitle from 'components/TextComps/Subtitle';
import Paragraph from 'components/TextComps/Paragraph';
import { AdminModule, AdminModuleListEntryStatus } from 'types/admin/modules';
import { useGeneralStore } from 'stores/Admin/Editors/ModuleEditor/GeneralStore';
import { useServices } from 'index';
import { useQuery } from '@tanstack/react-query';

export const EditGeneral = () => {
  const generalData: Omit<AdminModule, 'chapters' | 'certifications'> & { loading: boolean; initializing: boolean } = useGeneralStore(
    (state) => state
  );
  const setImageId = useGeneralStore((state) => state.setImageId);
  const setTitle = useGeneralStore((state) => state.setTitle);
  const setStatus = useGeneralStore((state) => state.setStatus);
  const setShortDescription = useGeneralStore((state) => state.setShortDescription);
  const setFullDescription = useGeneralStore((state) => state.setFullDescription);

  const service = useServices().mediaService;
  const { data } = useQuery({
    queryKey: ['selectedImage', generalData.imageId],
    queryFn: () => service.getMedia(generalData.imageId),
    enabled: !!generalData.imageId,
    staleTime: Infinity,
  });
  const moduleStatusOptions: AdminModuleListEntryStatus[] = ['Visible', 'ComingSoon', 'Hidden'];

  return (
    <div className='edit-admin-module'>
      {!generalData.initializing ? (
        <>
          <div className='section-wrapper'>
            <Subtitle>
              <>Status</>
            </Subtitle>
            <Select
              label='Select a status'
              value={generalData.status as string}
              className='narrow-select'
              required
              selectOptions={moduleStatusOptions.map((option) => ({
                label: option === 'ComingSoon' ? 'Coming Soon' : option,
                value: option,
              }))}
              disabled={generalData.loading}
              onChange={(e) => setStatus(e.target.value as AdminModuleListEntryStatus)}
            />
          </div>

          <div className='section-wrapper'>
            <Subtitle>
              <>Title & Description</>
            </Subtitle>
            <Input
              label='Title'
              required
              value={generalData.title}
              disabled={generalData.loading}
              onChange={(e) => setTitle(e.target.value)}
            />
            <Input
              label='Short Description'
              required
              value={generalData.shortDescription}
              disabled={generalData.loading}
              onChange={(e) => setShortDescription(e.target.value)}
            />
            <TextArea
              label='Long Description'
              required
              value={generalData.fullDescription}
              disabled={generalData.loading}
              onChange={(e) => setFullDescription(e.target.value)}
            />
          </div>

          <div className='section-wrapper'>
            <div>
              <Subtitle>
                <>Image*</>
              </Subtitle>
              <Paragraph>
                <>
                  This image will show in the card and banner on the <span style={{ fontWeight: 600 }}>Module Overview</span> and{' '}
                  <span style={{ fontWeight: 600 }}>Module Details</span> pages
                </>
              </Paragraph>
            </div>
            <BannerImage image={data} disabled={generalData.loading} handleSelectedImage={setImageId} />
          </div>
        </>
      ) : (
        <LoadingPlaceholder />
      )}
    </div>
  );
};
